import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUp, Star, X } from "lucide-react";
import { CONSTANTS } from "../data";

interface LevelUpNotificationProps {
  level: number | null;
  onComplete: () => void;
}

const LevelUpNotification: React.FC<LevelUpNotificationProps> = ({
  level,
  onComplete,
}) => {
  useEffect(() => {
    if (level) {
      const timer = setTimeout(onComplete, CONSTANTS.NOTIFICATION_DURATION);
      return () => clearTimeout(timer);
    }
  }, [level, onComplete]);

  return (
    <AnimatePresence>
      {level && (
        <motion.div
          initial={{ opacity: 0, y: -20, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 20, scale: 0.95 }}
          transition={{ ease: "easeOut", duration: 0.3 }}
          className="fixed top-24 right-6 bg-surface text-text-primary font-semibold px-6 py-4 rounded-lg shadow-lg z-50 border border-border-color flex items-center gap-4"
        >
          <div className="text-accent">
            <Star size={24} />
          </div>
          <div>
            <div className="text-sm text-text-secondary">Level Up!</div>
            <div className="text-lg">You've reached Level {level}!</div>
          </div>
          <button
            onClick={onComplete}
            className="absolute top-2 right-2 text-text-secondary hover:text-text-primary transition-colors p-1 rounded-full hover:bg-bg-main"
            aria-label="Close notification"
          >
            <X size={18} />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default LevelUpNotification;
